/***************************************************************************************************

 Copyright 2023-2024 Fannie Mae. All rights reserved.
 This software contains confidential information and trade secrets of Fannie Mae.
 Use, disclosure, or reproduction is prohibited without the prior written consent of Fannie Mae.

 ****************************************************************************************************/

import {apiEndpoints, environment, dusGatewayUrl} from '../../environments/environment';
import {Injectable} from '@angular/core';

const apiSpringBootPath = environment.baseUrl + '/mfdstcf/mfdstdn';
const endPoints = {
  'cdxUserInfoUrl': '/userdetails',
  'getSubmittedFilesData': '/getSubmittedFilesData',
  'getSubmittedInsuranceFilesData': '/getSubmittedInsuranceFilesData',
  'getAcquisitionDashboardList' : '/getAcquisitionDealDetails',
  'getAcqInsuranceDashboardList' : '/getAcqInsuranceDetails',
  "getLenderActionRequired" : "/getLenderActionRequired",
  "getLenderInsuranceActionRequired" : "/getLenderInsuranceActionRequired",
  'getFileStatus': '/getFileStatus',
  'getSellerServicerData': '/getsellerservicerdata',
  'setAcquisitionReportFlags':'/setAcquisitionReportFlags',
  'processFileUpload':'/processFileUpload',
  'getdocwayPreAuth':'/upload/permission'
};

@Injectable()
export class EndpointsService {

  constructor() {
  }

  setApiPath(target) {
    if (environment.environmentName == "mock") {
      return environment.baseUrl;
    }
    else if (environment.hostName == "localhost") {
      return 'http://localhost:5000/mfdstdn';
    } else {
      //return apiSpringBootPath;
      if (target === 'dd') {
        return environment.baseUrl + '/mfdstcf/dd_dashboard/mfdstdn';
      }else if (target === 'docway') {
        return environment.baseUrl + '/mfdstcf/dd_dashboard/docway';
      }
    }
  }

  getUploadEndpoint() {
    if (environment.hostName.includes("localhost")) {
      return environment.uploadEndpointDev;
    } else if (environment.hostName.includes("devl")) {
      return environment.uploadEndpointDev;
    } else if (environment.hostName.includes("test")) {
      return environment.uploadEndpointTest;
    } else if (environment.hostName.includes("acpt")) {
      return environment.uploadEndpointAcpt;
    } else if (environment.hostName.includes("dusdatadigitizer")) {
      return environment.uploadEndpointProd;
    }
  }

  logoutFromApp() {
    if (environment.hostName.includes("localhost")) {
      return apiEndpoints['mfdstcf.mfdstdn.mfbu.devl.intgfanniemae.com'].logoutUrl;
    } else {
      return apiEndpoints[window.location.hostname].logoutUrl;
    }
  }

  getSellerServicerEndpoint() {
    return this.getEndpoints().getSellerServicerData;
  }

  getInternalDUSGatewayURL() {
    if (environment.hostName.includes("localhost")) {
      return dusGatewayUrl.dusGatewayInternalLowerEnv;
    } else if (environment.hostName.includes("devl")) {
      return dusGatewayUrl.dusGatewayInternalLowerEnv;
    } else if (environment.hostName.includes("test")) {
      return dusGatewayUrl.dusGatewayInternalLowerEnv;
    } else if (environment.hostName.includes("acpt")) {
      return dusGatewayUrl.dusGatewayInternalLowerEnv;
    } else if (environment.hostName.includes("dusdatadigitizer")) {
      return dusGatewayUrl.dusGatewayInternalProd;
    }
  }

  getExternalDUSGatewayURL() {
    if (environment.hostName.includes("localhost")) {
      return dusGatewayUrl.dusGatewayExternalLowerEnv;
    } else if (environment.hostName.includes("devl")) {
      return dusGatewayUrl.dusGatewayExternalLowerEnv;
    } else if (environment.hostName.includes("test")) {
      return dusGatewayUrl.dusGatewayExternalLowerEnv;
    } else if (environment.hostName.includes("acpt")) {
      return dusGatewayUrl.dusGatewayExternalLowerEnv;
    } else if (environment.hostName.includes("dusdatadigitizer")) {
      return dusGatewayUrl.dusGatewayExternalProd;
    }
  }

  getEndpoints() {
    return endPoints;
  }
}
